import React, { useEffect, useState, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import clock from '../../../assets/icons/signage-plus/clock.svg';
import calendar from '../../../assets/icons/signage-plus/calendar.svg';
import weather from '../../../assets/icons/signage-plus/weather.svg';
import { SIGNAGE_MEDIA } from '../../../utils/constants';
import './CreateSignage.css';

const WidgetsModel = ({
  widgetsData,
  setError,
  closeModal,
  zone,
  setZone,
}) => {

  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });
  const [selectedWidget, setSelectedWidget] = useState(null);
  const [buttonProps, setButtonProps] = useState('');
  const widgetList = [
    {
      key: 'clock',
      img: clock,
      label: <FormattedMessage id="CLOCK" defaultMessage="Clock" />,
      buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#clockModal' },
    },
    {
      key: 'calendar',
      img: calendar,
      label: <FormattedMessage id="CALENDAR" defaultMessage="Calendar" />,
      buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#calendarModal' }
    },
    {
      key: 'weather',
      img: weather,
      label: <FormattedMessage id="SIGNAGE_WEATHER" defaultMessage="Weather" />,
      buttonProps: { 'data-bs-toggle': 'modal', 'data-bs-target': '#weatherModal' }
    }
  ];


  useEffect(() => {
    if (zone !== SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1 && zone !== SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET2)
      return;

    if (widgetsData) {
      setSelectedWidget(widgetsData.content.type || null);
      const selectedWidgetData = widgetList.find(widget => widget.key === widgetsData.content.type);
      if (selectedWidgetData) {
        setButtonProps(selectedWidgetData.buttonProps);
      }
    } else {
      setSelectedWidget(null);
      setButtonProps('');
    }
  }, [widgetsData, zone]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedWidget) {
      setError(<FormattedMessage id='SELECT_WIDGET' defaultMessage='Please select a widget.' />);
      return;
    }
    closeModal('widgetsModal');
  };

  const handleWidgetSelect = (widget) => {
    setSelectedWidget(widget.key);
    setButtonProps(widget.buttonProps);

    closeModal('widgetsModal');
  };

  return (
    <div className='modal modal-mse fade' id='widgetsModal' tabIndex='-1' aria-labelledby='widgetsModalLabel' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content modal-mes-content'>
          <div className='modal-header modal-mes-header' style={{ backgroundColor: '#347BFA' }}>
            <h5 className='modal-title modal-mes-title'><FormattedMessage id='WIDGETS' /></h5>
            <button id="closeModal" type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
          </div>
          <div className='modal-body'>
            <form onSubmit={handleSubmit}>
              <div className="row g-3 justify-content-between">
                {widgetList.map(widget => (
                  <div className="col d-flex justify-content-center" key={widget.key}>
                    <div
                      className={`card border-primary widget-panel${selectedWidget === widget.key ? ' widget-panel-selected' : ''}`}
                      {...widget.buttonProps}
                      onClick={() => handleWidgetSelect(widget)}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      <div className="d-flex flex-column align-items-center justify-content-center p-3 widget-panel-unselectable">
                        <img src={widget.img} alt={widget.key} className="widget-panel-img widget-panel-unselectable" draggable={false} />
                        <div className="mt-2 text-center widget-panel-title font-weight-600 font-size-14 widget-panel-unselectable">
                          {widget.label}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </form>
          </div>
          <div className='modal-footer modal-mes-footer d-flex align-items-center'>
            <button id="cancelModalBtn" type='button' className='btn btn-outline-secondary me-3' data-bs-dismiss='modal'>
              <FormattedMessage id='CANCEL' />
            </button>
            <button id="addWidgetBtn" className='btn btn-primary but-darkblue' {...buttonProps} type='button' onClick={handleSubmit}>
              <FormattedMessage id='ADD_WIDGET' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WidgetsModel;
